export default __webpack_public_path__ + "static/27728-6af601f298f10804ab4641057a97c9b1.jpg";